import { ImagePreviewEventType } from '../@types'
import { CUSTOM_EVENT_CLOSE_IMAGE_PREVIEW, CUSTOM_EVENT_OPEN_IMAGE_PREVIEW } from '../constant'

export const openImagePreview = ({ images, index = 0, thumbnails = [] }: ImagePreviewEventType) => {
  const event = new CustomEvent(CUSTOM_EVENT_OPEN_IMAGE_PREVIEW, {
    detail: { images, index, thumbnails },
  })
  window.dispatchEvent(event)
}

export const closeImagePreview = () => {
  window.dispatchEvent(new Event(CUSTOM_EVENT_CLOSE_IMAGE_PREVIEW))
}
